require('@github/details-dialog-element')
require('@github/details-menu-element')

const context = require.context('.', true, /_element.(j|t)s$/)
context.keys().forEach(context)
